<template>
  <div class="container">
    <div class="title">{{ $t('asset').flashcash }}</div>
    <div class="info">
      <!-- 币种选择 -->
      <div class="accoountInfo">
        <div class="left">
          <!-- 从 USDT-->
          <div class="item" v-if="activeFrom == 'USDT'">
            <span> {{ $t('asset').From }}</span>
            <img class="img" :src="require(`@/assets/img/USDT.png`)" />
            <div class="name">USDT</div>
          </div>
          <!-- 从 其他币种 -->
          <van-popover v-model="showPopover_from" placement="bottom" :actions="actions" @select="onSelect_from" v-if="activeFrom != 'USDT'">
            <template #reference>
              <div class="item" @click="showPopover_from = !showPopover_from">
                <span> {{ $t('asset').From }}</span>
                <img class="img" :src="require(`@/assets/img/${activeFrom}.png`)" v-if="assetType == 4" />
                <img class="img" :src="logoUrl" v-if="assetType == 3" />
                <div class="name">{{ activeFrom }}</div>
                <van-icon name="arrow-down" size="13" color="var(--ntext_color)" />
              </div>
            </template>
          </van-popover>
          <div class="line"></div>
          <!-- 到 USDT-->
          <div class="item" v-if="activeTo == 'USDT'">
            <span> {{ $t('asset').To }}</span>
            <img class="img" :src="require(`@/assets/img/USDT.png`)" />
            <div class="name">USDT</div>
          </div>
          <!-- 到 其他币种 -->
          <van-popover v-model="showPopover_to" placement="bottom" :actions="actions" @select="onSelect_to" v-if="activeTo != 'USDT'">
            <template #reference>
              <div class="item" @click="showPopover_to = !showPopover_to">
                <span>{{ $t('asset').To }}</span>
                <img class="img" :src="require(`@/assets/img/${activeTo}.png`)" v-if="assetType == 4" />
                <img class="img" :src="logoUrl" v-if="assetType == 3" />
                <div class="name">{{ activeTo }}</div>
                <van-icon name="arrow-down" size="13" color="var(--ntext_color)" />
              </div>
            </template>
          </van-popover>
        </div>
        <svg-icon class-name="svgs" icon-class="transfer" @click="changeAccount" />
      </div>
      <!-- 账户 -->
      <div class="tit">{{ $t('auth').AccountType }}</div>
      <PopoverSelect :items="assetTypeArr" :onSelect="onSelectAssetType">
        <template #reference>
          <div class="accountInfoss">{{ assetType == 3 ? $t('asset').Spotaccount : $t('asset').Walletaccount }}
            <span> <van-icon name="play" size="13" class="ric" color="var(--text_color)" /></span>
          </div>
        </template>
      </PopoverSelect>
      <!-- 数量 -->
      <div class="tit">{{ $t('asset').quantity }}</div>
      <div class="numInfo">
        <van-field v-model="Amount" :placeholder="$t('recharge').amountMsg" @input="onInputNum">
          <template #right-icon>
            <span style="color: var(--ntext_color)">{{ activeFrom }}</span>
          </template>
        </van-field>
      </div>
      <!-- 选择百分比 -->
      <div class="sliderPrecent">
        <van-slider v-model="activePrecent" @change="handlePrecent" bar-height="7" button-size="12" active-color="var(--text_color)" inactive-color="var(--info_color)">
        </van-slider>
        <div class="slable"><span>0%</span><span>25%</span><span>50%</span><span>75%</span><span>100%</span></div>
      </div>
      <div class="lables">{{ $t('asset').availablebalance }}<span>{{ AssetBalance }} {{ activeFrom }}</span></div>
      <div class="pricess">1 {{ activeFrom }} ≈ {{ newPrice }} {{ activeTo }}</div>
      <!-- 按钮 -->
      <van-button block @click="handleSub">{{ $t('public').confirm }}</van-button>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import productApi from '@/api/product'
import PopoverSelect from '@/components/popoverSelect.vue'
import { webSocket } from "@/mixins/webSocket.js";
export default {
  mixins: [webSocket],
  components: {
    PopoverSelect
  },
  data() {
    return {
      baseUrl: window.baseURL,
      actions: [
        { text: 'ETH', symbol: 'HBethusdt' },
        { text: 'BTC', symbol: 'HBbtcusdt' },
        { text: 'SOL', symbol: 'HBsolusdt' },
        { text: 'TON', symbol: 'HBtonusdt' },
        { text: 'USDC', symbol: 'HBusdcusdt' },
        { text: 'BNB', symbol: 'HBbnbusdt' },
        { text: 'XRP', symbol: 'HBxrpusdt' },
        { text: 'DAI', symbol: 'HBdaiusdt' },
        { text: 'PYUSD', symbol: 'HBpyusdusdt' },
      ],
      symbol: 'HBethusdt',
      logoUrl: '',
      assetType: 4,
      showassetType: false,
      assetTypeArr: [
        { text: this.$t('asset').Walletaccount, val: 4 },
        { text: this.$t('asset').Spotaccount, val: 3 },
      ],
      newPrice: 0,
      showPopover_from: false,
      showPopover_to: false,
      activeFrom: 'ETH',
      activeTo: 'USDT',
      activePrecent: 0,//余额百分比
      Amount: '',
      AssetBalance: 0
    }
  },
  async mounted() {
    window.scrollTo(0, 0);
    //资产类型
    if (this.$route.query.t) {
      this.assetType = this.$route.query.t
    }
    //现货产品
    if (this.assetType == 3) {
      this.getProductList()
    }
    else {
      //币种
      if (this.$route.query.b) {
        this.activeFrom = this.$route.query.b
        this.symbol = this.actions.find(item => item.text == this.$route.query.b).symbol
        this.logoUrl = this.actions.find(item => item.text == this.$route.query.b).logoUrl
      }
      this.getAssetBalance()
    }
  },
  //销毁之前
  beforeDestroy() {
    this.websockClose();
  },
  methods: {
    //选择资产账户
    async onSelectAssetType(action) {
      this.assetType = action.val
      this.showassetType = false
      //现货产品
      if (this.assetType == 3) {
        this.getProductList()
      } else {
        this.actions = [
          { text: 'ETH', symbol: 'HBethusdt' },
          { text: 'BTC', symbol: 'HBbtcusdt' },
          { text: 'SOL', symbol: 'HBsolusdt' },
          { text: 'TON', symbol: 'HBtonusdt' },
          { text: 'USDC', symbol: 'HBusdcusdt' },
          { text: 'BNB', symbol: 'HBbnbusdt' },
          { text: 'XRP', symbol: 'HBxrpusdt' },
          { text: 'DAI', symbol: 'HBdaiusdt' },
          { text: 'PYUSD', symbol: 'HBpyusdusdt' },
        ]
      }
      // 默认选择第一个
      this.activeFrom = this.actions[0].text
      this.activeTo = 'USDT'
      this.symbol = this.actions[0].symbol
      this.logoUrl = this.actions[0].logoUrl
      this.getAssetBalance()
    },
    // 获取现货产品列表
    async getProductList() {
      const res = await productApi.getProductList({ pageNum: 1, pageSize: 1000, productBusiness: 3 })
      this.actions = res.rows.map(item => ({
        text: item.name.split('/')[0],
        symbol: item.symbol,
        logoUrl: this.baseUrl + item.logoUrl
      }))
      // 没有指定币种 默认选择第一个
      if (!this.$route.query.b) {
        this.activeFrom = this.actions[0].text
        this.activeTo = 'USDT'
        this.symbol = this.actions[0].symbol
        this.logoUrl = this.actions[0].logoUrl
      }
      //币种
      if (this.$route.query.b) {
        this.activeFrom = this.$route.query.b
        this.activeTo = 'USDT'
        this.symbol = this.actions.find(item => item.text == this.$route.query.b).symbol
        this.logoUrl = this.actions.find(item => item.text == this.$route.query.b).logoUrl
      }
      this.getAssetBalance()
    },
    // 选择From账户
    async onSelect_from(action) {
      this.activeFrom = action.text
      this.symbol = action.symbol
      this.logoUrl = action.logoUrl
      this.getAssetBalance()
    },
    // 选择To账户
    async onSelect_to(action) {
      this.activeTo = action.text
      this.symbol = action.symbol
      this.logoUrl = action.logoUrl
      this.getAssetBalance()
    },
    // 切换账户
    async changeAccount() {
      const temp = this.activeTo
      this.activeTo = this.activeFrom
      this.activeFrom = temp
      this.Amount = ''
      this.onInputNum()
      this.getAssetBalance()
    },
    //选择百分比滑块
    handlePrecent() {
      this.Amount = ((this.activePrecent / 100) * this.AssetBalance).toFixed(6).replace(/\.?0+$/, '')
    },
    //输入数量事件
    onInputNum() {
      this.activePrecent = Number(this.Amount / this.AssetBalance * 100)
      if (this.activePrecent > 100) this.activePrecent = 100
      if (this.Amount > this.AssetBalance)
        this.$toast(this.$t('asset').Insufficientavailablebalance)
    },
    // 获取资产余额
    async getAssetBalance() {
      const res = await userApi.getAssetBalance({ assetType: this.assetType, currency: this.activeFrom })
      this.AssetBalance = res.assetWallet.amount
      this.getCurrencyNewPrice()
    },
    // 获取币种最新价格
    async getCurrencyNewPrice() {
      const res = await userApi.getCurrencyNewPrice({ symbol: this.symbol })
      if (this.activeFrom == 'USDT')
        this.newPrice = (1 / res.data).toFixed(6).replace(/\.?0+$/, '')
      else
        this.newPrice = res.data
      this.webSocketInit(() => {
        this.websocketInfoGet()
      })
    },
    //推送单品
    websocketInfoGet() {
      let that = this
      // 订阅产品给价格赋值
      const subRequest = {
        action: 'SubAdd',
        content: [that.symbol]
      };
      that.websockSend(JSON.stringify(subRequest), (reslult) => {
        //产品详情
        let quotesInfo = reslult.find(item => item.Symbol == that.symbol);
        if (quotesInfo) {
          if (that.activeFrom == 'USDT')
            that.newPrice = (1 / quotesInfo.NewPrice).toFixed(6).replace(/\.?0+$/, '')
          else
            that.newPrice = quotesInfo.NewPrice
        }
      })
    },
    // 提交
    async handleSub() {
      if (!this.Amount) {
        this.$toast({ message: this.$t('recharge').amountMsg })
        return false
      }
      if (this.Amount > this.AssetBalance) {
        this.$toast(this.$t('asset').Insufficientavailablebalance)
        return false
      }
      const form = {
        assetType: this.assetType,
        fromCurrency: this.activeFrom,
        toCurrency: this.activeTo,
        symbol: this.symbol,
        amount: this.Amount,
      }
      await userApi.flashcash(form)
      this.$toast(this.$t('asset').flashcashsuccessful)
      this.$router.go(-1)
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  width: 100%;
  background: var(--background_color);

  .title {
    font-size: 36px;
    font-weight: bold;
    color: var(--text_color);
    margin: 0 auto;
    max-width: 1280px;
    padding-bottom: 40px;
    border-bottom: 1px solid var(--info_color);
  }

  .info {
    margin: 0 auto;
    max-width: 480px;
  }

  .accountInfoss {
    margin: 10px 0 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid var(--info_color);
    border-radius: 10px;
    padding: 15px;
    font-size: 16px;
    font-weight: bold;
    color: var(--text_color);
    &:hover {
      border: 1px solid var(--text_color);
    }
  }

  .accoountInfo {
    margin: 20px 0;
    padding: 15px;
    border: 1px solid var(--info_color);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      width: 100%;

      .item {
        display: flex;
        align-items: center;

        span {
          color: var(--ntext_color);
          font-size: 13px;
        }

        .img {
          margin-left: 20px;
          width: 20px;
          height: 20px;
          border-radius: 50%;

          &:hover {
            opacity: 0.8;
          }
        }

        .name {
          margin: 0 5px;
          font-size: 16px;
          font-weight: bold;
          color: var(--text_color);

          &:hover {
            opacity: 0.8;
          }
        }
      }

      .line {
        margin: 15px 0;
        border-bottom: 1px dashed var(--info_color);
      }
    }

    .svgs {
      margin-left: 15px;
      width: 27px;
      height: 27px;
      color: var(--text_color);

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .tit {
    margin-top: 10px;
    font-size: 13px;
    color: var(--text_color);
  }

  .ric {
    transform: rotate(90deg);
  }

  .selInfo {
    margin: 10px 0 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid var(--info_color);
    border-radius: 10px;
    height: 50px;
    padding: 15px;

    .left {
      display: flex;
      align-items: center;

      .img {
        width: 20px;
        height: 20px;
        border-radius: 50%;
      }

      .name {
        margin-left: 10px;
        font-size: 16px;
        font-weight: bold;
        color: var(--text_color);
      }
    }
  }

  .numInfo {
    margin-top: 10px;
  }

  .sliderPrecent {
    margin: 20px 5px;

    .slable {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      color: var(--ntext_color);
    }
  }

  .lables {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: right;
    font-size: 13px;
    color: var(--ntext_color);

    span {
      margin-left: 10px;
      color: var(--text_color);
      font-weight: bold;
    }
  }

  .pricess {
    margin-top: 70px;
    font-size: 13px;
    text-align: center;
    color: var(--ntext_color);
  }

  .van-button {
    margin: 10px 0;
    background: var(--text_color);
    height: 40px;
    border-radius: 20px;
    border: 0;
    font-size: 15px;
    color: var(--background_color);
  }
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

.van-cell {
  background: var(--background_color);
  border: 1px solid var(--info_color);
  height: 50px;
  padding: 10px;
  border-radius: 10px;
  font-size: 20px;
  font-weight: bold;
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__right-icon {
  margin: -10px 8px;
  padding: 0px;
  line-height: normal;
  font-size: 15px;
}
</style>
